// import React from 'react';
// import './ModelCollection.css';

// const collections = [
//   { id: 1, name: 'BRIDAL', img: '' },
//   { id: 2, name: 'KURTIS', img: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?q=80&w=500' },
//   { id: 3, name: 'SOLID COLOURS', img: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?q=80&w=500' },
//   { id: 4, name: 'NAVRATRI COLLECTION', img: 'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?q=80&w=500' },
//   { id: 5, name: 'WITH SLEEVE', img: 'https://images.unsplash.com/photo-1621112904887-419379ce6824?q=80&w=500' },
//   { id: 6, name: 'BOLLYWOOD COLLECTION', img: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?q=80&w=500' },
// ];

// const CollectionsGrid = () => {
//   return (
//     <section className="collections-section">
//       <div className="collections-grid">
//         {collections.map((item) => (
//           <div key={item.id} className="collection-card">
//             <img src={item.img} alt={item.name} className="collection-image" />
//             <div className="collection-overlay">
//               <span className="collection-name">{item.name}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default CollectionsGrid;



import React from 'react';
import { useSelector } from 'react-redux'; 
import { useNavigate } from 'react-router-dom'; 
import { getOptimizedUrl } from '../../../../constants/globalFunction'; 
import './ModelCollection.css';

const CollectionsGrid = () => {
  const navigate = useNavigate();
  
  const { categories } = useSelector((state) => state.categoryState);

  const handleCategoryClick = (category) => {
    navigate(`/category?category_id=${category?._id}`, {
      state: { category: category },
    });
  };

  if (!categories || categories.length === 0) return null;

  return (
    <section className="collections-section">
      <div className="collections-grid">
        {categories.slice(0, 6).map((cat) => (
          <div 
            key={categories._id} 
            className="collection-card" 
            onClick={() => handleCategoryClick(cat)}
          >
            <img 
              src={getOptimizedUrl(cat.image)} 
              alt={categories.name} 
              className="collection-image" 
            />
            <div className="collection-overlay">
              <span className="collection-name">{cat.name}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CollectionsGrid;
